'use strict';

var isEdge = require('./is-edge');
var isSamsung = require('./is-samsung');

module.exports = function isChrome(ua) {
  ua = ua || navigator.userAgent;
  return (ua.indexOf('Chrome') !== -1 || ua.indexOf('CriOS') !== -1) && !isEdge(ua) && !isSamsung(ua);
};



//////////////////
// WEBPACK FOOTER
// ../node_modules/@braintree/browser-detection/is-chrome.js
// module id = 1078
// module chunks = 0